export default {
    "en": {
        "A fresh verification link has been sent to your email address.": "A fresh verification link has been sent to your email address.",
        "All rights reserved.": "All rights reserved.",
        "Before proceeding, please check your email for a verification link.": "Before proceeding, please check your email for a verification link.",
        "click here to request another": "click here to request another",
        "Confirm Password": "Confirm Password",
        "E-Mail Address": "E-Mail Address",
        "Forbidden": "Forbidden",
        "Forgot Your Password?": "Forgot Your Password?",
        "Go Home": "Go Home",
        "Hello!": "Hello!",
        "If you did not create an account, no further action is required.": "If you did not create an account, no further action is required.",
        "If you did not receive the email": "If you did not receive the email",
        "If you did not request a password reset, no further action is required.": "If you did not request a password reset, no further action is required.",
        "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser: [{actionURL}]({actionURL})": "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser: [{actionURL}]({actionURL})",
        "Invalid signature.": "Invalid signature.",
        "Login": "Login",
        "Logout": "Logout",
        "Name": "Name",
        "Not Found": "Not Found",
        "Oh no": "Oh no",
        "Page Expired": "Page Expired",
        "Password": "Password",
        "Please click the button below to verify your email address.": "Please click the button below to verify your email address.",
        "Regards": "Regards",
        "Register": "Register",
        "Remember Me": "Remember Me",
        "Reset Password": "Reset Password",
        "Reset Password Notification": "Reset Password Notification",
        "Send Password Reset Link": "Send Password Reset Link",
        "Server Error": "Server Error",
        "Service Unavailable": "Service Unavailable",
        "This action is unauthorized.": "This action is unauthorized.",
        "This password reset link will expire in {count} minutes.": "This password reset link will expire in {count} minutes.",
        "Toggle navigation": "Toggle navigation",
        "Too Many Attempts.": "Too Many Attempts.",
        "Too Many Requests": "Too Many Requests",
        "Unauthorized": "Unauthorized",
        "Verify Email Address": "Verify Email Address",
        "Verify Your Email Address": "Verify Your Email Address",
        "You are receiving this email because we received a password reset request for your account.": "You are receiving this email because we received a password reset request for your account.",
        "Your email address is not verified.": "Your email address is not verified.",
        "Whoops!": "Whoops!",
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "socialite": {
                "unacceptable": "{provider} is not an acceptable login type."
            }
        },
        "buttons": {
            "cancel": "Cancel",
            "save": "Save",
            "close": "Close",
            "create": "Create",
            "delete": "Delete",
            "confirm": "Confirm",
            "show": "Show",
            "edit": "Edit",
            "update": "Update",
            "view": "View",
            "preview": "Preview",
            "back": "Back",
            "send": "Send",
            "login-as": "Login as {name}",
            "apply": "Apply"
        },
        "labels": {
            "language": "Language",
            "actions": "Actions",
            "general": "General",
            "no_results": "No results available",
            "search": "Search",
            "validate": "Validate",
            "choose_file": "Choose File",
            "no_file_chosen": "No file chosen",
            "are_you_sure": "Are you sure ?",
            "delete_image": "Delete image",
            "yes": "Yes",
            "no": "No",
            "add_new": "Add",
            "export": "Export",
            "more_info": "More info",
            "author": "Author",
            "author_id": "Author ID",
            "last_access_at": "Last access at",
            "published_at": "Published at",
            "created_at": "Created at",
            "updated_at": "Updated at",
            "deleted_at": "Deleted at",
            "no_value": "No value",
            "upload_image": "Upload image",
            "anonymous": "Anonymous",
            "all_rights_reserved": "All rights reserved.",
            "with": "with",
            "by": "by",
            "options": "Options",
            "morphs": {
                "user": "User, identity {id}"
            },
            "auth": {
                "disabled": "Your account has been disabled."
            },
            "http": {
                "403": {
                    "title": "Access Denied",
                    "description": "Sorry, but you do not have permissions to access this page."
                },
                "404": {
                    "title": "Page Not Found",
                    "description": "Sorry, but the page you were trying to view does not exist."
                },
                "500": {
                    "title": "Server Error",
                    "description": "Sorry, but the server has encountered a situation it doesn't know how to handle. We'll fix this as soon as possible."
                }
            },
            "localization": {
                "en": "English",
                "lt": "Lithuanian"
            },
            "placeholders": {
                "route": "Select a valid internal route",
                "tags": "Select or create a tag"
            },
            "cookieconsent": {
                "message": "This website uses cookies to ensure you get the best experience on our website.",
                "dismiss": "Got it !"
            },
            "descriptions": {
                "allowed_image_types": "Allowed types: png gif jpg jpeg."
            },
            "user": {
                "dashboard": "Dashboard",
                "remember": "Remember",
                "login": "Login",
                "logout": "Logout",
                "password_forgot": "Forget password ?",
                "send_password_link": "Send reset password link",
                "password_reset": "Password Reset",
                "register": "Register",
                "space": "My space",
                "settings": "Settings",
                "account": "My account",
                "profile": "My profile",
                "avatar": "Avatar",
                "online": "Online",
                "edit_profile": "Edit my profile",
                "change_password": "Change my password",
                "delete": "Delete my account",
                "administration": "Administration",
                "member_since": "Member since {date}",
                "profile_updated": "Profile successfully updated.",
                "password_updated": "Password successfully updated.",
                "super_admin": "Super administrateur",
                "account_delete": "<p>This action will delete entirely your account from this site as well as all associated data.</p>",
                "account_deleted": "Account successfully deleted",
                "titles": {
                    "space": "My space",
                    "account": "My account"
                }
            },
            "alerts": {
                "login_as": "You are actually logged as <strong>{name}</strong>, you can logout as <a href=\"{route}\" data-turbolinks=\"false\">{admin}</a>."
            }
        },
        "languages": [],
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "translations": {
            "messages": {
                "validation-fail": "An error occurred while validating data.",
                "between-rule": "Length of field content must be between {min} and {max} characters"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "Name",
                "display_name": "Display name",
                "username": "Pseudo",
                "email": "Email",
                "first_name": "Firstname",
                "last_name": "Lastname",
                "password": "Password",
                "password_confirmation": "Confirm password",
                "old_password": "Old password",
                "new_password": "New password",
                "new_password_confirmation": "Confirm new password",
                "postal_code": "Postal code",
                "city": "City",
                "country": "Country",
                "address": "Address",
                "phone": "Phone",
                "mobile": "Mobile",
                "age": "Age",
                "sex": "Sex",
                "gender": "Gender",
                "day": "Day",
                "month": "Month",
                "year": "Year",
                "hour": "Hour",
                "minute": "Minute",
                "second": "Second",
                "title": "Title",
                "content": "Content",
                "description": "Description",
                "summary": "Summary",
                "excerpt": "Excerpt",
                "date": "Date",
                "time": "Time",
                "available": "Available",
                "size": "Size",
                "roles": "Roles",
                "permissions": "Permissions",
                "active": "Active",
                "message": "Message",
                "g-recaptcha-response": "Captcha",
                "locale": "Localization",
                "route": "Route",
                "url": "URL alias",
                "form_type": "Form type",
                "form_data": "Form data",
                "recipients": "Recipients",
                "source_path": "Original path",
                "target_path": "Target path",
                "redirect_type": "Redirect type",
                "timezone": "Timezone",
                "order": "Display order",
                "image": "Image",
                "status": "Status",
                "pinned": "Pinned",
                "promoted": "Promoted",
                "body": "Body",
                "tags": "Tags",
                "published_at": "Publish at",
                "unpublished_at": "Unpublish at",
                "metable_type": "Entity",
                "price": "Price"
            }
        }
    },
    "lt": {
        "A fresh verification link has been sent to your email address.": "A fresh verification link has been sent to your email address.",
        "All rights reserved.": "All rights reserved.",
        "Before proceeding, please check your email for a verification link.": "Before proceeding, please check your email for a verification link.",
        "click here to request another": "click here to request another",
        "Confirm Password": "Confirm Password",
        "E-Mail Address": "E-Mail Address",
        "Forbidden": "Forbidden",
        "Forgot Your Password?": "Forgot Your Password?",
        "Go Home": "Go Home",
        "Hello!": "Hello!",
        "If you did not create an account, no further action is required.": "If you did not create an account, no further action is required.",
        "If you did not receive the email": "If you did not receive the email",
        "If you did not request a password reset, no further action is required.": "If you did not request a password reset, no further action is required.",
        "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser: [{actionURL}]({actionURL})": "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser: [{actionURL}]({actionURL})",
        "Invalid signature.": "Invalid signature.",
        "Login": "Login",
        "Logout": "Logout",
        "Name": "Name",
        "Not Found": "Not Found",
        "Oh no": "Oh no",
        "Page Expired": "Page Expired",
        "Password": "Password",
        "Please click the button below to verify your email address.": "Please click the button below to verify your email address.",
        "Regards": "Regards",
        "Register": "Register",
        "Remember Me": "Remember Me",
        "Reset Password": "Reset Password",
        "Reset Password Notification": "Reset Password Notification",
        "Send Password Reset Link": "Send Password Reset Link",
        "Server Error": "Server Error",
        "Service Unavailable": "Service Unavailable",
        "This action is unauthorized.": "This action is unauthorized.",
        "This password reset link will expire in {count} minutes.": "This password reset link will expire in {count} minutes.",
        "Toggle navigation": "Toggle navigation",
        "Too Many Attempts.": "Too Many Attempts.",
        "Too Many Requests": "Too Many Requests",
        "Unauthorized": "Unauthorized",
        "Verify Email Address": "Verify Email Address",
        "Verify Your Email Address": "Verify Your Email Address",
        "You are receiving this email because we received a password reset request for your account.": "You are receiving this email because we received a password reset request for your account.",
        "Your email address is not verified.": "Your email address is not verified.",
        "Whoops!": "Whoops!",
        "account": {
            "button": {
                "login": "Prisijungti",
                "register_egate": "Registruotis"
            },
            "label": {
                "email": "El. pašto adresas",
                "login_to_your_account": "Prisijungti prie savo paskyros",
                "password": "Slaptažodis",
                "register_egate": "Neturite paskyros ?",
                "register_egate_info": "Registruotis per El.valdžios vartus"
            },
            "msg": {
                "login-success": "Sėkmingai prisijungta"
            },
            "nav": {
                "login": "Prisijungti",
                "register": "Registruotis"
            },
            "placeholder": {
                "email": "Įveskite savo el.pašto adresą"
            },
            "title": {
                "login": "Prisijungti"
            },
            "validation": {
                "login-required": "Neįvestas el.pašto adresas",
                "password-required": "Neįvestas slaptažodis"
            }
        },
        "assets": {
            "actions": {
                "destroy": "Delete selected assets",
                "disable": "Disable selected assets",
                "enable": "Enable selected assets"
            },
            "alerts": {
                "bulk_destroyed": "Selected assets deleted",
                "bulk_disabled": "Selected assets disabled",
                "bulk_enabled": "Selected assets enabled",
                "created": "Asset created",
                "deleted": "Asset deleted",
                "disabled": "Asset disabled",
                "enabled": "Asset enabled",
                "updated": "Asset updated"
            },
            "button": {
                "close": "Uždaryti peržiūra",
                "download": "Parsisiųsti failą",
                "empty-upload": "Įkelti failą",
                "print": "Spausdinti",
                "cancel": "Atšaukti",
                "confirm_action": "Patvirtinti",
                "error_confirm": "Supratau",
                "success_confirm": "Supratau"
            },
            "buttons": {
                "create": "Create Asset",
                "empty-upload": "Įkelti failą"
            },
            "exceptions": {
                "bulk_destroy": "Error on deleting selected assets",
                "bulk_disable": "Error on disabling selected assets",
                "bulk_enable": "Error on enabling selected assets"
            },
            "label": {
                "of": "Iš"
            },
            "permissions": {
                "category": "Assets",
                "create": {
                    "display_name": "Create assets"
                },
                "delete": {
                    "display_name": "Delete assets"
                },
                "edit": {
                    "display_name": "Edit assets"
                },
                "view": {
                    "display_name": "View assets"
                }
            },
            "sidebar": {
                "title": "Assets"
            },
            "titles": {
                "create": "Asset creation",
                "edit": "Asset edit",
                "list": "Assets",
                "unit": "Asset",
                "units": "Assets"
            }
        },
        "auth": {
            "failed": "Neteisingti prisijungimo duomenys",
            "throttle": "Perdaug bandymų prisijungti. Bandykite po {seconds} sec.",
            "socialite": {
                "unacceptable": "{provider} neleidžia prisijungti."
            }
        },
        "basket": {
            "button": {
                "cart": "Krepšelis",
                "checkout": "Į atsiskaitymą",
                "need_more_question": "need more ?"
            },
            "label": {
                "checkout": "Į atsiskaitymą",
                "total": "Viso"
            }
        },
        "buttons": {
            "cancel": "Atšaukti",
            "save": "Saugoti",
            "close": "Uždaryti",
            "create": "Sukurti",
            "delete": "Trinti",
            "confirm": "Patvirtinti",
            "show": "Rodyti",
            "edit": "Koreguoti",
            "update": "Atnaujinti",
            "view": "Peržiūra",
            "preview": "Peržiūrėti",
            "back": "Atgal",
            "send": "Siųsti",
            "login-as": "Prisijungta {name}",
            "apply": "Taikyti"
        },
        "checkout": {
            "error": {
                "address": "Prašome pridėti adresą",
                "city": "Prašome įrašyti miestą",
                "company": "Prašome įrašyti įmonės pavadinimą",
                "company_code": "Prašome įrašyti įmonės kodą",
                "country": "Prašome pasirinkti šalį",
                "email": "Prašome įrašyti el. paštą",
                "lastname": "Prašome įrašyti pavardę",
                "name": "Prašome įrašyti vardą",
                "payer_type": "Prašome nurodyti mokėtojo tipą",
                "phone": "Prašome įrašyti tel. nr.",
                "vat_number": "Prašome įrašyti VAT numerį",
                "zip_code": "Prašome įrašyti pašto kodą"
            },
            "label": {
                "address": "Adresas",
                "city": "Miestas",
                "company": "Įmonės pavadinimas",
                "company_code": "Įmonės kodas",
                "country": "Šalis",
                "email": "Elektroninis paštas",
                "name": "Vardas",
                "payer_type": "Mokėtojo tipas",
                "phone": "Telefono numeris",
                "select_address": "Pasirinkite adresą iš jūsų įmonių",
                "select_company": "Pasirinkti įmonę",
                "simply_fill": "Arba tiesiog užpildykite atsiskaitymo adreso formą",
                "surname": "Pavardė",
                "vat_number": "VAT numeris",
                "zip_code": "Pašto kodas"
            },
            "note": {
                "fill_required": "Prašome užpildyti būtinus laukelius"
            }
        },
        "labels": {
            "language": "Kalba",
            "actions": "Veiksmai",
            "general": "Pagrindinis",
            "no_results": "Rezultatų nėra",
            "search": "Ieškoti",
            "validate": "Vykdyti",
            "choose_file": "Pasirinkti failą",
            "no_file_chosen": "Failas neparinktas",
            "are_you_sure": "Ar tikrai ?",
            "delete_image": "Trinti paveiksliuką",
            "yes": "Taip",
            "no": "Ne",
            "add_new": "Pridėti",
            "export": "Eksportuoti",
            "more_info": "Daugiau",
            "author": "Autorius",
            "author_id": "Autoriaus ID",
            "last_access_at": "Paskutinį kartą prisijungta",
            "published_at": "Paskelbta",
            "created_at": "Sukurta",
            "updated_at": "Atnaujinta",
            "deleted_at": "Ištrinta",
            "no_value": "Nėra reikšmės",
            "upload_image": "Įkelti paveiksliuką",
            "anonymous": "Anonimas",
            "all_rights_reserved": "Visos teisės saugomos.",
            "with": "su",
            "by": "by",
            "options": "Variantai / Pasirinkimai",
            "morphs": {
                "user": "Vartotojas, identifikatorius {id}"
            },
            "auth": {
                "disabled": "Jūsų paskyra buvo užblokuota."
            },
            "http": {
                "403": {
                    "title": "Access Denied",
                    "description": "Sorry, but you do not have permissions to access this page."
                },
                "404": {
                    "title": "Page Not Found",
                    "description": "Sorry, but the page you were trying to view does not exist."
                },
                "500": {
                    "title": "Server Error",
                    "description": "Sorry, but the server has encountered a situation it doesn't know how to handle. We'll fix this as soon as possible."
                }
            },
            "localization": {
                "en": "Anglų k.",
                "lt": "Lietuvių k."
            },
            "placeholders": {
                "route": "Select a valid internal route",
                "tags": "Select or create a tag"
            },
            "cookieconsent": {
                "message": "This website uses cookies to ensure you get the best experience on our website.",
                "dismiss": "Got it !"
            },
            "descriptions": {
                "allowed_image_types": "Allowed types: png gif jpg jpeg."
            },
            "user": {
                "dashboard": "Dashboard",
                "remember": "Prisiminti",
                "login": "Prisijungti",
                "logout": "Atsijungti",
                "password_forgot": "Pamiršote slaptažodį ?",
                "send_password_link": "Siųsti slaptažodžio keitimo nuorodą",
                "password_reset": "Slaptažodžio keitimas",
                "register": "Registruotis",
                "space": "Mano erdvė",
                "settings": "Nustatymai",
                "account": "Mano paskyra",
                "profile": "Mano profilis",
                "avatar": "Avatar",
                "online": "Online",
                "edit_profile": "Koreguoti mano profilį",
                "change_password": "Keisti mano slaptažodį",
                "delete": "Trinti mano paskyrą",
                "administration": "Adminisravimas",
                "member_since": "Narys nuo {date}",
                "profile_updated": "Anketa sėkmingai atnaujinta.",
                "password_updated": "Slaptaždosis sėkmingai atnaujintas.",
                "super_admin": "Super administratorius",
                "account_delete": "<p>This action will delete entirely your account from this site as well as all associated data.</p>",
                "account_deleted": "Account successfully deleted",
                "titles": {
                    "space": "Mano erdvė",
                    "account": "Mano paskyra"
                }
            },
            "alerts": {
                "login_as": "You are actually logged as <strong>{name}</strong>, you can logout as <a href=\"{route}\" data-turbolinks=\"false\">{admin}</a>."
            }
        },
        "orders": {
            "action": {
                "view": "Peržiūrėti"
            },
            "button": {
                "download_invoice": "Atsisiųsti sąskaitą faktūrą"
            },
            "label": {
                "address": "Adresas:",
                "code": "Kodas",
                "company_code": "Įmonės kodas:",
                "date": "Data:",
                "description": "Aprašymas",
                "from": "Nuo",
                "invoice": "Sąskaita faktūra",
                "invoice_sign": "Sąskaitos faktūra Nr .:",
                "line_total": "Viso",
                "owner_company_city_zip": "City, LT-xxxxx",
                "owner_company_code": "Company code: xxxxxxx",
                "owner_company_country": "Lithuania",
                "owner_company_phone": "Phone: +370 xxxxxxx",
                "owner_company_subtitle": "Company sub title",
                "owner_company_title": "Company title",
                "phone": "Telefono numeris:",
                "qty": "Kiekis",
                "subtotal": "Tarpinė suma",
                "tax": "Mokesčiai",
                "title": "Kiekis",
                "to": "Iki",
                "total": "Iš viso",
                "unit_price": "Vieneto kaina",
                "vat_number": "VAT numeris:"
            },
            "message": {
                "change_search": "Prašome pakeisti paieškos kriterijus",
                "no_results": "Nieko nerasta",
                "please_wait": "Prašome palaukti ..."
            },
            "placeholder": {
                "date_from": "Data nuo",
                "date_to": "Data iki",
                "filter_by_status": "Pagal statusą",
                "search_by_id": "Ieškoti pagal ID"
            },
            "status": {
                "awaiting": "Laukiama mokėjimo",
                "canceled": "Atšauktas mokėjimas",
                "completed": "Mokėjimas atliktas",
                "partial": "Dalinis mokėjimas"
            },
            "title": {
                "order": "Užsakymas"
            }
        },
        "pagination": {
            "previous": "&laquo; Ankstesnis",
            "next": "Sekantis &raquo;"
        },
        "passwords": {
            "password": "Slaptažodis turi būti bent šešių simbolių ir sutapti su patvirtinimu.",
            "reset": "Nustatytas naujas slaptažodis!",
            "sent": "Naujo slaptažodžio nustatymo nuoroda išsiųsta",
            "token": "Šis slaptažodžio raktas yra neteisingas.",
            "user": "Vartotojas su tokiu el. paštu nerastas."
        },
        "services": {
            "label": {
                "please-select": "-- Prašome pasirinkti --"
            },
            "nav": {
                "services": "Paslaugos"
            },
            "status": {
                "accepted": "Priimta",
                "all_records": "Visi įrašai",
                "canceled": "Atmesta",
                "completed": "Įvykdyta",
                "draft": "Sukurta",
                "ordered": "Užsakyta",
                "payment_pending": "Laukiama apmokėjimo",
                "payment_received": "Apmokėta",
                "register": "Registruota",
                "reviewed": "Peržiūrėta",
                "revise": "Tikslinama"
            },
            "validation": {
                "msg-max": "Simbolių kiekis lauke \"<strong>{label}</strong>\" negali būti didesnis nei <strong>{max}</strong>.",
                "msg-min": "Simbolių kiekis lauke \"<strong>{label}</strong>\" negali būti mažesnis nei <strong>{min}</strong>.",
                "msg-required": "Privaloma užpildyti lauką \"<strong>{label}</strong>\"."
            }
        },
        "tenders": {
            "label": {
                "please-select": "-- Prašome pasirinkti --"
            },
            "nav": {
                "tenders": "Konkursai"
            },
            "status": {
                "register": "Registruota",
                "draft": "Juodraštis",
                "submitted": "Pateikta",
                "approved": "Patvirtinta",
                "rejected": "Atmesta",
                "pending": "Laukiama",
                "unknown": "Nežinoma",
                "revise": "Tikslinama",
                "revise_expired": "Atmesta"
            },
            "validation": {
                "msg-max": "Simbolių kiekis lauke \"<strong>{label}</strong>\" negali būti didesnis nei <strong>{max}</strong>.",
                "msg-min": "Simbolių kiekis lauke \"<strong>{label}</strong>\" negali būti mažesnis nei <strong>{min}</strong>.",
                "msg-required": "Privaloma užpildyti lauką \"<strong>{label}</strong>\"."
            },
            "alerts": {
                "created": "Prašymas sukurtas",
                "updated": "Prašymas atnaujintas",
                "deleted": "Prašymas ištrintas"
            }
        },
        "translations": {
            "messages": {
                "validation-fail": "An error occurred while validating data.",
                "between-rule": "Length of field content must be between {min} and {max} characters"
            }
        },
        "users": {
            "buttons": {
                "login": "Prisijungti",
                "register": "Registruotis",
                "save": "Saugoti",
                "verify": "Patvirtinti telefono numerį"
            },
            "errors": {
                "verification_code": "Įvestas neteisingas patvirtinimo kodas!"
            },
            "labels": {
                "email": "El. paštas",
                "email_address": "El. pašto adresas",
                "have_account": "Jei turite paskyrą?",
                "name": "Vardas",
                "no_account": "Jei neturite paskyros?",
                "opt_code": "Įveskite į jūsų numerį atsiųstą OTP",
                "or": "Arba",
                "password": "Slaptažodis",
                "password_new": "Naujas slaptažodis",
                "password_new_confirm": "Pakartoti naują slaptaždodį",
                "phone": "Telefonas",
                "phone_number": "Telefono numeris",
                "remember": "Prisiminti",
                "surname": "Pavardė",
                "verification_code": "Patvirtinimo kodas",
                "your_email": "Jūsų el.pašto adresas",
                "your_name": "Jūsų vardas",
                "your_phone": "Jūsų telefonas",
                "your_surname": "Jūsų pavardė"
            },
            "messages": {
                "phone_number_verified": "Telefono numeris patvirtintas",
                "registration_can_login": "Galite prisijungti",
                "registration_completed": "Jūsų paskyra sėkmingai sukurta"
            },
            "nav": {
                "login": "Prisijungti",
                "login_have_account": "Prisijunkite",
                "logout": "Atsijungti",
                "password_forgot": "Pamiršote slaptažodį ?",
                "profile": "Anketa",
                "register": "Registruotis",
                "register_for_no_account": "Registruokitės",
                "settings": "Nustatymai"
            },
            "titles": {
                "change_password": "Slaptažodžio keitimas",
                "login": "Prisijungti",
                "register": "Registruotis",
                "sub_login_text": "Prisijungti prie savo paskyros",
                "verify": "Patvirtinkite savo telefono numerį"
            }
        },
        "validation": {
            "accepted": "Laukas {attribute} turi būti priimtas.",
            "active_url": "Laukas {attribute} nėra galiojantis internetinis adresas.",
            "after": "Lauko {attribute} reikšmė turi būti po {date} datos.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "Laukas {attribute} gali turėti tik raides.",
            "alpha_dash": "Laukas {attribute} gali turėti tik raides, skaičius ir brūkšnelius.",
            "alpha_num": "Laukas {attribute} gali turėti tik raides ir skaičius.",
            "array": "Laukas {attribute} turi būti masyvas.",
            "before": "Laukas {attribute} turi būti data prieš {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "Lauko {attribute} reikšmė turi būti tarp {min} ir {max}.",
                "file": "Failo dydis lauke {attribute} turi būti tarp {min} ir {max} kilobaitų.",
                "string": "Simbolių skaičius lauke {attribute} turi būti tarp {min} ir {max}.",
                "array": "Elementų skaičius lauke {attribute} turi turėti nuo {min} iki {max}."
            },
            "boolean": "Lauko reikšmė {attribute} turi būti 'taip' arba 'ne'.",
            "confirmed": "Lauko {attribute} patvirtinimas nesutampa.",
            "date": "Lauko {attribute} reikšmė nėra galiojanti data.",
            "date_format": "Lauko {attribute} reikšmė neatitinka formato {format}.",
            "different": "Laukų {attribute} ir {other} reikšmės turi skirtis.",
            "digits": "Laukas {attribute} turi būti sudarytas iš {digits} skaitmenų.",
            "digits_between": "Laukas {attribute} tuti turėti nuo {min} iki {max} skaitmenų.",
            "dimensions": "Lauke {attribute} įkeltas paveiksliukas neatitinka išmatavimų reikalavimo.",
            "distinct": "Laukas {attribute} pasikartoja.",
            "email": "Lauko {attribute} reikšmė turi būti galiojantis el. pašto adresas.",
            "file": "The {attribute} must be a file.",
            "filled": "Laukas {attribute} turi būti užpildytas.",
            "exists": "Pasirinkta negaliojanti {attribute} reikšmė.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "Lauko {attribute} reikšmė turi būti paveikslėlis.",
            "in": "Pasirinkta negaliojanti {attribute} reikšmė.",
            "in_array": "Laukas {attribute} neegzistuoja {other} lauke.",
            "integer": "Lauko {attribute} reikšmė turi būti sveikasis skaičius.",
            "ip": "Lauko {attribute} reikšmė turi būti galiojantis IP adresas.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "Lauko {attribute} reikšmė turi būti JSON tekstas.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "Lauko {attribute} reikšmė negali būti didesnė nei {max}.",
                "file": "Failo dydis lauke {attribute} reikšmė negali būti didesnė nei {max} kilobaitų.",
                "string": "Simbolių kiekis lauke {attribute} reikšmė negali būti didesnė nei {max} simbolių.",
                "array": "Elementų kiekis lauke {attribute} negali turėti daugiau nei {max} elementų."
            },
            "mimes": "Lauko reikšmė {attribute} turi būti failas vieno iš sekančių tipų: {values}.",
            "mimetypes": "Lauko reikšmė {attribute} turi būti failas vieno iš sekančių tipų: {values}.",
            "min": {
                "numeric": "Lauko {attribute} reikšmė turi būti ne mažesnė nei {min}.",
                "file": "Failo dydis lauke {attribute} turi būti ne mažesnis nei {min} kilobaitų.",
                "string": "Simbolių kiekis lauke {attribute} turi būti ne mažiau nei {min}.",
                "array": "Elementų kiekis lauke {attribute} turi būti ne mažiau nei {min}."
            },
            "not_in": "Pasirinkta negaliojanti reikšmė {attribute}.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "Lauko {attribute} reikšmė turi būti skaičius.",
            "present": "Laukas {attribute} turi egzistuoti.",
            "regex": "Negaliojantis lauko {attribute} formatas.",
            "required": "Privaloma užpildyti lauką {attribute}.",
            "required_if": "Privaloma užpildyti lauką {attribute} kai {other} yra {value}.",
            "required_unless": "Laukas {attribute} yra privalomas, nebent {other} yra tarp {values} reikšmių.",
            "required_with": "Privaloma užpildyti lauką {attribute} kai pateikta {values}.",
            "required_with_all": "Privaloma užpildyti lauką {attribute} kai pateikta {values}.",
            "required_without": "Privaloma užpildyti lauką {attribute} kai nepateikta {values}.",
            "required_without_all": "Privaloma užpildyti lauką {attribute} kai nepateikta nei viena iš reikšmių {values}.",
            "same": "Laukai {attribute} ir {other} turi sutapti.",
            "size": {
                "numeric": "Lauko {attribute} reikšmė turi būti {size}.",
                "file": "Failo dydis lauke {attribute} turi būti {size} kilobaitai.",
                "string": "Simbolių skaičius lauke {attribute} turi būti {size}.",
                "array": "Elementų kiekis lauke {attribute} turi būti {size}."
            },
            "string": "Laukas {attribute} turi būti tekstinis.",
            "timezone": "Lauko {attribute} reikšmė turi būti galiojanti laiko zona.",
            "unique": "Tokia {attribute} reikšmė jau pasirinkta.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "Negaliojantis lauko {attribute} formatas.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "Pavadinimas",
                "display_name": "Rodomas pavadinimas",
                "username": "Pseudo",
                "email": "El. paštas",
                "first_name": "Vardas",
                "last_name": "Pavardė",
                "password": "Slaptažodis",
                "password_confirmation": "Pakartoti slaptažodį",
                "old_password": "Senas slaptažodis",
                "new_password": "Naujas slaptažodis",
                "new_password_confirmation": "Confirm new password",
                "postal_code": "Pašto kodas",
                "city": "Miestas",
                "country": "Šalis",
                "address": "Adresas",
                "phone": "Telefonas",
                "mobile": "Mobilus",
                "age": "Amžius",
                "sex": "Sex",
                "gender": "Gender",
                "day": "Diena",
                "month": "Mėnuo",
                "year": "Metai",
                "hour": "Valanda",
                "minute": "Minutė",
                "second": "Sekundė",
                "title": "Title",
                "content": "Turinys",
                "description": "Apibudinimas",
                "summary": "Summary",
                "excerpt": "Excerpt",
                "date": "Data",
                "time": "Laikas",
                "available": "Available",
                "size": "Dydis",
                "roles": "Rolės",
                "permissions": "Leidimai",
                "active": "Aktyvus",
                "enabled": "Aktyvus",
                "disabled": "Neaktyvus",
                "message": "Žinutė",
                "g-recaptcha-response": "Captcha",
                "locale": "Localization",
                "route": "Route",
                "url": "URL adresas",
                "url-target": "URL nuoroda",
                "url-target-info": "URL nuoroda galite pasiekti tik tuo atveju jei elementas nėra išjungtas.",
                "url-description": "Jei URL adreso lauko neužpildysite jis bus automatiškai sugeneruotas iš pavadinimo.",
                "form_type": "Form type",
                "form_data": "Form data",
                "recipients": "Recipients",
                "source_path": "Original path",
                "target_path": "Target path",
                "redirect_type": "Redirect type",
                "timezone": "Timezone",
                "order": "Pozicija",
                "position": "Pozicija",
                "image": "Image",
                "status": "Statusas",
                "pinned": "Pinned",
                "promoted": "Promoted",
                "body": "Body",
                "tags": "Tags",
                "published_at": "Paskelbta",
                "unpublished_at": "Unpublish at",
                "metable_type": "Entity",
                "working_hours": "Darbo laikas",
                "zip": "Pašto kodas",
                "coordinates": "Koordinatės",
                "price": "Kaina"
            }
        }
    }
}
